import { initialise as initialiseUsers } from './Users/initialisers';
import { initialise as initialisePages } from './Pages/initialisers';
import { initialise as initialiseCertificationPathways } from './Certification/CertificationPathways/initialisers';
import { initialise as initialiseChannels } from './Channels/initialisers';
import { initialise as initialiseComments } from './Comments/initialisers';
import { initialise as initialiseCourses } from './Courses/initialisers';
import { initialise as initialiseCohorts } from './Cohorts/initialisers';
import { initialise as initialiseEnrolments } from './Enrolments/initialisers';
import { initialise as initialiseGroupTypes } from './GroupTypes/initialisers';
import { initialise as initialiseInstitutions } from './Institutions/initialisers';
import { initialise as initialiseNotificationEvents } from './NotificationEvents/initialisers';
import { initialise as initialisePosts } from './Posts/initialisers';
import { initialise as initialiseQualifications } from './Qualifications/initialisers';
import { initialise as initialiseQualificationEnrolments } from './QualificationEnrolments/initialisers';
import { initialise as initialiseSubscriptions } from './Subscriptions/initialisers';
import { initialise as initialiseCohortGroupsDataObjects } from './CohortGroups/initialisers';
import { initialise as initialiseLTIData } from './LTI/initialisers';

// DEPRECATION WARNING: initialising data from the DOM is incompatible with SPA links.
// Instead, Add a thunk to the relevant route in routesMap.jsx to load the data you need
export function initialiseFromDom(dispatch, getState) {
  // TODO: make this fail more gracefully
  initialiseCertificationPathways(dispatch, getState);
  initialiseChannels(dispatch, getState);
  initialiseComments(dispatch, getState);
  initialiseCourses(dispatch, getState);
  initialiseCohorts(dispatch, getState);
  initialiseEnrolments(dispatch, getState);
  initialiseGroupTypes(dispatch, getState);
  initialiseInstitutions(dispatch, getState);
  initialiseLTIData(dispatch, getState);
  initialiseNotificationEvents(dispatch, getState);
  initialisePages(dispatch, getState);
  initialiseQualifications(dispatch, getState);
  initialiseQualificationEnrolments(dispatch, getState);
  initialiseSubscriptions(dispatch, getState);
  initialiseUsers(dispatch, getState);
  initialiseCohortGroupsDataObjects(dispatch, getState);

  // Requires users to be initialised
  initialisePosts(dispatch, getState);
}
